import Entity from './entity'
export default class Gasdata extends Entity<number>{
   
}